import { z } from "zod";

export const GetMeditationDailyExampleSchema = z
  .object({
    meditationDailyId: z.string().min(1),
    includeUrl: z.enum(["true", "false"]).optional().default("false"),
    includeMetadata: z.enum(["true", "false"]).optional().default("true"),
  })
  .refine((data) => data.includeUrl === "true" || data.includeMetadata === "true", {
    message: "At least one of includeUrl or includeMetadata must be true",
  });

export type GetMeditationDailyExampleQueryParams = z.infer<typeof GetMeditationDailyExampleSchema>;

export interface GetMeditationDailyExampleResponse {
  imageUrl?: string;
  name?: string;
  duration?: number;
  authorName?: string;
  meditationDailyId?: string;
  url?: string;
}
